import BaseModel from './BaseModel';
import AutoScreeningJob from './AutoScreeningJob';
import Reference from './Reference';

export default class AutoScreeningClassification extends BaseModel {
  constructor(data = {}) {
    super(AutoScreeningClassification, data);
    this.id = data.id;
    this.autoScreeningJob = new AutoScreeningJob(
      data.autoScreeningJob
    );
    this.reference = data.reference
      ? new Reference(data.reference)
      : null;
    this.score = data.score;
  }
}
